import React from "react";

import classnames from "classnames";
import { map } from "lodash";
import PropTypes from "prop-types";

import type { SelectProps } from "Theme/Select";

import makeBem from "Utils/makeBem";

const bem = makeBem("CobaltSelect");
export const Select = ({ className, placeholder, noPlaceholder, options, name, input, meta, ...rest }: SelectProps) => {
  const classes = classnames(className, bem(), {
    [bem(null, "error")]: meta && meta.touched && meta.error !== undefined,
  });

  if (!Array.isArray(options)) {
    options = map(options, (value, label) => [value, label]);
  }

  return (
    <select className={classes} name={name} {...input} {...rest}>
      {!noPlaceholder && <option value="">{placeholder}</option>}
      {options.map(
        (
          [optionValue, label], // dont render empty option dom elements
        ) => optionValue && <option value={optionValue} key={optionValue} children={label} />,
      )}
    </select>
  );
};
Select.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  noPlaceholder: PropTypes.bool,
  disabled: PropTypes.bool,
  options: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.any,
    warning: PropTypes.any,
  }),
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
};
Select.defaultProps = {
  disabled: false,
  noPlaceholder: false,
  placeholder: "--------",
};
